import { render } from "./News.vue?vue&type=template&id=302a8c9b"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
script.render = render

export default script